"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var body_scroll_lock_1 = require("body-scroll-lock");
var MainNavigation = /** @class */ (function () {
    function MainNavigation() {
    }
    MainNavigation.prototype.onLoad = function ($element) {
        var $mobileMenuToggle = $element.$(".header__hamburger-toggler");
        var $headerNavigation = $element.$(".header__navigation-links");
        var $headerRow = $element.$(".Header__row");
        var $menuItems = $headerNavigation.$$(".menu-item");
        var untilRefresh = (0, DOMScript_1.makeUntilRefresh)();
        // Fix issue with Barba
        $element.classList.remove("--opened");
        (0, body_scroll_lock_1.clearAllBodyScrollLocks)();
        $menuItems &&
            untilRefresh((0, rxjs_1.from)($menuItems))
                .pipe((0, operators_1.map)(function ($el, index) { return ({ $el: $el, index: index }); }))
                .subscribe(function (_a) {
                var $el = _a.$el, index = _a.index;
                var $link = $el.querySelector("a");
                $el.$addStyle("--animation-delay: ".concat((index + 1) * 0.15, "s"));
                if ($link) {
                    $link.classList.add("--underlined-link");
                    $link.setAttribute("data-track", "");
                    $link.setAttribute("data-track-click-event", "menuClick");
                    $link.setAttribute("data-track-click-event-name", "menu_click");
                    $link.setAttribute("data-track-click-cta-label", $link === null || $link === void 0 ? void 0 : $link.text);
                }
            });
        if (!$mobileMenuToggle)
            return this;
        untilRefresh((0, rxjs_1.fromEvent)($mobileMenuToggle, "click"))
            .pipe((0, operators_1.scan)(function (isOpen) { return !isOpen; }, false))
            .subscribe(function (isOpen) {
            $element.$classAddOrRemoveIf(isOpen, "--opened");
            isOpen ? (0, body_scroll_lock_1.disableBodyScroll)($headerRow) : (0, body_scroll_lock_1.clearAllBodyScrollLocks)();
        });
        untilRefresh((0, rxjs_1.fromEvent)(window, "scroll"))
            .pipe((0, operators_1.map)(function () { return window.pageYOffset > 0; }), (0, operators_1.distinctUntilChanged)())
            .subscribe(function (isHidden) {
            return $element.$classAddOrRemoveIf(isHidden, "--scrolled");
        });
    };
    MainNavigation = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".Header"
        })
    ], MainNavigation);
    return MainNavigation;
}());
new MainNavigation();
